/** Round a number
 * @param {String} input floating number
 * @param {int} decimalCount number of decimal
 * @param {boolean} intIfPossible Return an integer without zero when possible. When the parameter is a float where the floating point is useless such as '1.0' , the result is an integer '1'. 
 * @return {String} rounded floating number.  
 */
export function getRoundedNumber(input, decimalCount, intIfPossible) {
    if (input) {
        if (decimalCount) {
            try {
                if (intIfPossible) {
                    if (parseInt(Number(input), 10) === Number(input)) {
                        return parseInt(Number(input), 10);
                    } else {
                        return Number(input).toFixed(decimalCount);
                    }
                } else {
                    return Number(input).toFixed(decimalCount);
                }
            }
            catch (e) {
                /** There was an error, we leave same value */
                console.log("[DatasetPanel] Error while converting the floating number.");
                return input;
            }
        }
        // when there is an input but no decimalCount, returns the number as is
        return input;
    }
    //when there is no input
    return null;
}

/**
 * Get the number in its exponential notiation
 * @param {String} input input number
 * @param {int} decimalCount Numebr of decimal requested
 * @returns {String} number in exponential notation
 */
export function getExponentialNotation(input, decimalCount) {
    if (input) {
        if (decimalCount) {
            try {
                return Number(Number(input).toFixed(decimalCount)).toExponential();
            }
            catch (e) {
                /** There was an error, we leave same value */
                return input;
            }
        }
        else {
            /** No decimals then same value */
            return input;
        }
    }
    //when there is no input
    return null;
}


// WEBPACK FOOTER //
// ./src/components/saxs/DataCollection/DataCollectionHelper.js